import { registerLocaleData } from '@angular/common';
import uk from '@angular/common/locales/uk';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app';
import { appConfig } from './app/app.config';

registerLocaleData(uk);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
